/**
 * `__Host-` and `Secure` need HTTPS, which local development lacks. Read from
 * NODE_ENV, which Next inlines into client bundles at build time, so the
 * browser that sets a cookie and the server that reads it agree on its name
 * as long as nothing overrides NODE_ENV at runtime.
 */
export const CLICK_NONCE_COOKIE_SECURE = process.env.NODE_ENV === "production";

/**
 * The cookie name for a click nonce. In production it carries the `__Host-`
 * prefix, which stops a sibling subdomain from setting it.
 */
export function clickNonceCookieName(name: string): string {
  return CLICK_NONCE_COOKIE_SECURE ? `__Host-${name}` : name;
}

/**
 * Writes a fresh nonce to `cookieName` and returns it, for a connect click to
 * put in the URL it sends the browser to. The route that receives the URL acts
 * only when its copy matches the cookie, which a link built anywhere else
 * can't arrange. Call it from the click itself.
 */
export function issueClickNonce(
  cookieName: string,
  options: { maxAgeSeconds: number; sameSite: "Lax" | "Strict" },
): string {
  const nonce = crypto.randomUUID();
  const secure = CLICK_NONCE_COOKIE_SECURE ? "; Secure" : "";
  // biome-ignore lint/suspicious/noDocumentCookie: set by the click that starts the round trip; Cookie Store API lacks broad support
  document.cookie = `${cookieName}=${nonce}; Path=/; Max-Age=${options.maxAgeSeconds}; SameSite=${options.sameSite}${secure}`;
  return nonce;
}
